import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 34 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y, scale: 0.985, filter: "blur(6px)" }}
    whileInView={{ opacity: 1, y: 0, scale: 1, filter: "blur(0px)" }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay }}
  >
    {children}
  </motion.div>
);

export const PageHeader = ({ eyebrow, title, subtitle, testid }) => (
  <div className="mx-auto max-w-3xl text-center">
    <Reveal>
      <p className="eyebrow">{eyebrow}</p>
    </Reveal>
    <Reveal delay={0.1}>
      <h1
        data-testid={testid}
        className="mt-4 font-serif text-4xl font-semibold leading-[1.1] tracking-tight text-[#1A1615] sm:text-5xl"
      >
        {title}
      </h1>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.2}>
        <p className="mt-5 text-base font-light leading-relaxed text-[#5A504B]">{subtitle}</p>
      </Reveal>
    )}
  </div>
);
